import React from 'react'
import { Tab, Menu, Icon, Label } from 'semantic-ui-react'
import ProductionTableData from '../ProductionTableData'
import AdjustmentTableData from '../AdjustmentTableData'
import WriteoffTableData from '../WriteoffTableData'
import CollectionTableData from '../CollectionTableData'
import CollectionTableObj from '../CollectionTableObj'
import PayStubTable from '../PayStubTable'
import GoxTableData from '../GoxTableData'
import UnallocatedHygienistTable from '../UnallocatedHygienistTable'
import Loading from '../../Loading'
import FamilyView from '../FamilyView'
import NextDays from '../NextDays'
import FamilyCapacityView from '../FamilyCapacityView'
import SumOf from '../NewReports/SumOf'
import GOz from '../NewReports/GOz'
import GreaterOf from '../NewReports/GreaterOf'
import GOx from '../NewReports/GOx'
import Collections from '../NewReports/Collections'

const EARNINGS_REPORT_COMPONENTS = {
  GOZ: GOz,
  GOX: GOx,
  'Greater Of': GreaterOf,
  Collections: Collections,
  'Sum Of': SumOf,
}

const ProductionContent = (props) => {
  const { reportDetailsData, tableDataArray, detailsModal, eventClick, openFamilyView, getPracticeName } = props;
  const isUkgHygienist = reportDetailsData?.isUkgHyn && reportDetailsData?.hygienistRecords?.length > 0;
  if (!isUkgHygienist) {
    return (
      <ProductionTableData
        getPracticeName={getPracticeName}
        openFamilyView={openFamilyView}
        detailsModal={detailsModal}
        reportData={tableDataArray}
        eventClick={eventClick}
        forcedTotal={props.reportBCareTotal}
      />
    )
  }

  const unallocatedCount = reportDetailsData.hygienistRecords.filter(
    r => !r.Treat_prov ||
      r.Treat_prov === r.Provider ||
      r.Treat_prov.split(/[|,]/).filter(
        p => p.trim() &&
          !p.toUpperCase().includes('HYG') &&
          !p.toUpperCase().includes('RDH')
      ).length > 1
  ).length

  return (
    <Tab panes={[
      {
        menuItem: (
          <Menu.Item key="bcare">
            <Icon name="dollar sign" />bCare
          </Menu.Item>
        ),
        render: () => (
          <Tab.Pane>
            <ProductionTableData
              getPracticeName={getPracticeName}
              openFamilyView={openFamilyView}
              detailsModal={detailsModal}
              reportData={tableDataArray}
              eventClick={eventClick}
              forcedTotal={props.reportBCareTotal}
            />
          </Tab.Pane>
        )
      },
      {
        menuItem: (
          <Menu.Item key="unallocated">
            <Icon name="exclamation triangle" color="orange" />
            Unallocated <Label color="orange" size="tiny">{unallocatedCount}</Label>
          </Menu.Item>
        ),
        render: () => (
          <Tab.Pane>
            <UnallocatedHygienistTable
              records={reportDetailsData.hygienistRecords}
              showOnlyUnallocated={true}
            />
          </Tab.Pane>
        )
      },
      {
        menuItem: (
          <Menu.Item key="all">
            <Icon name="users" color="blue" />
            All Records <Label color="blue" size="tiny">{reportDetailsData.hygienistRecords.length}</Label>
          </Menu.Item>
        ),
        render: () => (
          <Tab.Pane>
            <UnallocatedHygienistTable
              records={reportDetailsData.hygienistRecords}
              showOnlyUnallocated={false}
            />
          </Tab.Pane>
        )
      }
    ]} />
  )
}

const EarningsReport = ({ contractType, earningsReportOptions, commonProps, additionalProps }) => {
  const shouldShowEarningsReport =
    Object.keys(earningsReportOptions).length &&
    earningsReportOptions[contractType]

  if (!shouldShowEarningsReport) {
    return <PayStubTable {...commonProps} {...additionalProps} />
  }

  const ReportComponent = EARNINGS_REPORT_COMPONENTS[contractType]

  if (!ReportComponent) {
    return <PayStubTable {...commonProps} {...additionalProps} />
  }

  return <ReportComponent {...commonProps} {...additionalProps} />
}

const ModalContent = (props) => {
  const { detailsModalType, tableData, tableDataArray, detailsModal, contractType, earningsReportOptions } = props;
  if (tableData === null && detailsModalType !== 'collectionList') {
    return <Loading />
  }

  const contentMap = {
    nextDays: () => (
      <NextDays        {...props} practice={props.nextDaysData?.familyPractice} />
    ),
    familyCapacityView: () => (
      <FamilyCapacityView {...props} />
    ),
    familyView: () => (
      <FamilyView
        {...props}
        BrokenChildTable={props.familyData}
        BrokenChild={props.familyData?.brokenListChild}
      />
    ),
    production: () => (
      <ProductionContent {...props} />
    ),
    goxDetailsList: () =>
      detailsModal === 'goxContract' && (
        <GoxTableData          {...props} reportData={tableDataArray} />
      ),
    adjustment: () => (
      <AdjustmentTableData {...props} reportData={tableDataArray} />
    ),
    writeoff: () => (
      <WriteoffTableData        {...props} reportData={tableDataArray} />
    )
  }

  // Handle collections
  if (detailsModalType === 'collectionList') {
    if (detailsModal === 'report') {
      return (
        <CollectionTableObj {...props} />
      )
    }
    return (
      <CollectionTableData {...props} />
    )
  }

  // Handle payStub
  if (detailsModalType === 'payStub') {
    const commonProps = {
      ...props,
      contractType,
      earningsPerPractice: props.earningsPerPracticeData,
    }

    return (
      <EarningsReport
        contractType={contractType}
        earningsReportOptions={earningsReportOptions}
        commonProps={commonProps}
        additionalProps={props}
      />
    )
  }

  const renderContent = contentMap[detailsModalType]
  return renderContent ? renderContent() : null
}

export default ModalContent
